import type { CompletionEvent, KanhaChatConfig } from "./types";

export type CompletionEventBase = Omit<
  CompletionEvent,
  "outcome" | "rawModelCompletion" | "displayedAnswer" | "completedAt" | "error"
>;

export function completionEvent(
  base: CompletionEventBase,
  outcome: CompletionEvent["outcome"],
  rawModelCompletion: string,
  displayedAnswer: string,
  error?: unknown,
): CompletionEvent {
  return {
    ...base,
    outcome,
    rawModelCompletion,
    displayedAnswer,
    completedAt: new Date().toISOString(),
    ...(error === undefined ? {} : {
      error: error instanceof Error ? error.message : String(error),
    }),
  };
}

export function emitCompletion(config: KanhaChatConfig, event: CompletionEvent) {
  try {
    config.onCompletion?.(event);
  } catch {
  }
}
